export default __webpack_public_path__ + "static/media/send_comment.d5442e26.svg";